var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#2563EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_10450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 20.0003L19.3337 23.3337L24.667 16.667M20.0003 10.667L10.667 16.0003V16.9603C10.6667 19.7569 11.5775 22.4774 13.2616 24.71C14.9457 26.9426 17.3113 28.5657 20.0003 29.3337C22.6893 28.5657 25.055 26.9426 26.739 24.71C28.4231 22.4774 29.3339 19.7569 29.3337 16.9603V16.0003L20.0003 10.667Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_10450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalVerification);
export default __webpack_public_path__ + "static/media/Additional Verification.0b227ecb41230cc5b41ccb49a7b2bcb5.svg";
export { ForwardRef as ReactComponent };